var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0568 10.3262C10.9083 10.3262 13.2199 8.0146 13.2199 5.1631C13.2199 2.3116 10.9083 0 8.0568 0C5.2053 0 2.89371 2.3116 2.89371 5.1631C2.89371 8.0146 5.2053 10.3262 8.0568 10.3262Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.075 16.857C14.6902 13.6771 11.5615 11.6084 8.07389 11.6084C4.58625 11.6084 1.44053 13.66 0.0728199 16.857C-0.11524 17.2844 0.0728199 17.7631 0.500228 17.9512C0.551517 17.9853 0.619902 18.0024 0.671191 18.0024V18.0195H15.3056C15.4253 18.0195 15.545 18.0024 15.6476 17.9512C16.0579 17.7631 16.263 17.2844 16.075 16.857Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d26578db179c8cd63d2fe63502baa246.svg";
export { ForwardRef as ReactComponent };